<script setup>
import MdcChips from "@/components/Mdc/MdcChips.vue";
import MdcButton from "@/components/Mdc/MdcButton.vue";

const props = defineProps({
    categories: {
        type: Array,
        required: true,
    },
    activeCategory: {
        required: true,
    },
    subCategories: {
        type: Array,
        required: true,
    },
    activeSubCategories: {
        type: Array,
        required: true,
    },
});

const emit = defineEmits(["setCategory", "setSubCategories"]);

function setSubCategories(subCategories) {
    emit("setSubCategories", subCategories);
}
</script>

<template>
    <div>
        <div class="categories">
            <MdcButton
                v-for="category in props.categories"
                :label="category.label"
                :type="
                    props.activeCategory === category.value
                        ? 'tertiary__active'
                        : 'tertiary'
                "
                @click="emit('setCategory', category)"
            />
        </div>
        <div class="sub-categories" v-if="props.subCategories.length">
            <MdcChips
                :active-chips="props.activeSubCategories"
                :list="props.subCategories"
                @update="setSubCategories"
            />
        </div>
    </div>
</template>

<style scoped lang="scss">
@use "@/scss/design-library/colors";
.categories {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 9px;
    align-items: flex-start;
    justify-content: center;

    padding-bottom: 24px;

    border-bottom: 2px solid #{colors.$grey};

    button {
        display: block;
    }
}
.sub-categories {
    padding-top: 32px;
}
</style>
